import { Button, Col, Row } from "antd";
import styles from "./Services.module.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
export function Services() {
  const { t } = useTranslation();

  const services = [
    {
      text: "Frontend development",
      style: "servicesFrontend",
      path: "/services/frontend",
    },
    {
      text: "Backend development",
      style: "servicesBackend",
      path: "/services/backend",
    },
    {
      text: "Application & Websites",
      style: "servicesWebSite",
      path: "/services/web-applications",
    },
    {
      text: `UI/UX Design`,
      style: "servicesDesign",
      path: "/services/design",
    },
  ];
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.pageWrapper}>
        <Row gutter={[24, 24]} style={{ flexDirection: "column" }}>
          {services.map((v) => (
            <Col className={`${styles.services} ${styles[v.style]}`} span={24}>
              <h1 className={styles.title}>{v.text}</h1>
              <Button
                onClick={() =>
                  navigate({
                    pathname: v.path,
                  })
                }
                className={styles.seeMore}
              >
                {t("buttons.seeMore")}
              </Button>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}
